<template>
  <form class="columns is-multiline" @submit.prevent="saveConfiguration">
    <b-field class="column is-12" label="Habilitar registro de interacciones" label-position="horizontal">
      <b-switch
        v-model="form.valor"
        true-value="1"
        false-value="0"
        size="is-medium"
      >
        {{ form.valor === '1' ? 'Activado' : 'Desactivado' }}
      </b-switch>
    </b-field>

    <b-field class="column is-12" label="Descripción" label-position="horizontal">
      <b-input
        v-model="form.descripcion"
        placeholder="Detalle opcional para esta configuración"
        type="textarea"
      ></b-input>
    </b-field>

    <div class="column is-12">
      <b-button :loading="loading" class="is-primary" native-type="submit" expanded>
        Guardar configuración
      </b-button>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'ConfigurationsForm',
  props: {
    configuration: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        clave: 'interacciones_habilitadas',
        descripcion: '',
        valor: '1',
      },
    };
  },
  watch: {
    configuration: {
      handler(newValue) {
        this.form = {
          id: newValue?.id ?? null,
          clave: newValue?.clave ?? 'interacciones_habilitadas',
          descripcion: newValue?.descripcion ?? '',
          valor: newValue?.valor !== undefined ? String(newValue.valor) : '1',
        };
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      submitForm: 'configurations/submitForm',
    }),
    async saveConfiguration() {
      this.loading = true;
      try {
        const response = await this.submitForm(this.form);

        Swal.fire({
          icon: response?.status ? 'success' : 'error',
          title: response?.message || 'No se pudo actualizar la configuración',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: true,
        });

        if (response?.status) {
          this.$emit('saved');
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'No se pudo actualizar la configuración',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: true,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.columns {
  max-width: 720px;
}
</style>
